import {BreakpointType} from "./types";

const landscape = " and (min-aspect-ratio: 1/1)";
const portrait = " and (max-aspect-ratio: 1/1)";

export const SMALL = "small";
export const MEDIUM = "medium";
export const LARGE = "large";
export const XLARGE = "x-large";

export const defaultBreakpoint: BreakpointType = {
  size: XLARGE,
  // NOTE: Even when the portrait media query is matching,
  // once we hit x-large, the landscape layout is applied.
  // For this reason, we're broadcasting 'landscape'
  orientation: "landscape",
  media: `(min-width: 1024px)${portrait}`,
};

export const breakpoints: Array<BreakpointType> = [
  {
    size: SMALL,
    orientation: "portrait",
    media: `(max-width: 567px)`,
  },
  // Removed "landscape" orientation for max-width: 567px
  // and max-width: 300px on Feb 2021.
  // It was causing Android soft-keyboard issues,
  // and is not actively used.
  {
    size: MEDIUM,
    orientation: "landscape",
    media: `(max-width: 767px) and (min-width: 568px)${landscape}`,
  },
  {
    size: MEDIUM,
    orientation: "portrait",
    media: `(max-width: 767px) and (min-width: 568px)${portrait}`,
  },
  {
    size: LARGE,
    orientation: "landscape",
    media: `(max-width: 1023px) and (min-width: 768px)${landscape}`,
  },
  {
    size: LARGE,
    orientation: "portrait",
    media: `(max-width: 1023px) and (min-width: 768px)${portrait}`,
  },
  {
    size: XLARGE,
    orientation: "landscape",
    media: `(min-width: 1024px)${landscape}`,
  },
  defaultBreakpoint,
  {
    size: XLARGE,
    orientation: "landscape",
    media: "(min-width: 1200px)",
  },
];
